module.exports = __webpack_public_path__ + "img/fg-antes-10@3x.310b56f8.jpg";